import { useCallback, useEffect, useState } from 'react';
import apiClient from '../../../requests/api/apiClient';
import { PeakHourConfig } from '../../../requests/api/apiTypes';

interface UsePeakHoursResult {
  configByPumpSystemId: Map<number, PeakHourConfig>;
  loading: boolean;
  refetch: () => void;
}

const usePeakHours = (farmId: string | undefined): UsePeakHoursResult => {
  const [configByPumpSystemId, setConfigByPumpSystemId] = useState<Map<number, PeakHourConfig>>(
    new Map(),
  );
  const [loading, setLoading] = useState(false);
  const [version, setVersion] = useState(0);

  const refetch = useCallback(() => setVersion((v) => v + 1), []);

  useEffect(() => {
    let isMounted = true;
    if (!farmId) {
      setConfigByPumpSystemId(new Map());
      return undefined;
    }

    setLoading(true);
    const load = async () => {
      try {
        const { data } = await apiClient.peakHour.getPeakHours(farmId);
        if (!isMounted || !data) return;
        setConfigByPumpSystemId(new Map(
          (data.configs ?? []).map((config) => [config.pumpSystemId, config]),
        ));
      } catch {
        // Fallo silencioso: sin datos de hora punta no se muestra el candado activo
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    load();

    return () => {
      isMounted = false;
    };
  }, [farmId, version]);

  return { configByPumpSystemId, loading, refetch };
};

export default usePeakHours;
